import { render, staticRenderFns } from "./CorporateMockupTables.vue?vue&type=template&id=4bdc39ee&scoped=true"
import script from "./CorporateMockupTables.vue?vue&type=script&lang=js"
export * from "./CorporateMockupTables.vue?vue&type=script&lang=js"
import style0 from "./CorporateMockupTables.vue?vue&type=style&index=0&id=4bdc39ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc39ee",
  null
  
)

export default component.exports